export default {"src":"/_next/static/media/logo.e95f1a32.svg","height":53,"width":357};